module.exports = __webpack_public_path__ + "img/audio_pause_background.5fb8dbfc.png";